import React, { Fragment, useEffect, useState } from 'react'
import Image from '@boltui/image'

import { breakpointPx } from '../../helpers/ContentHelper'
import PageSkeleton from '../../components/Skeletons/PageSkeleton'
import styles from './HomepageComponents.scss'

const HomepageComponents = ({ homepageData, onCmsClick, isResettingData }) => {
  const [heroImgWidth, setHeroImageWidth] = useState('545')
  useEffect(() => {
    const isInBetween = window.innerWidth >= breakpointPx.SMALL && window.innerWidth <= breakpointPx.LARGE
    if (isInBetween) setHeroImageWidth(window.innerWidth.toString())
  }, [])

  if (isResettingData) return <PageSkeleton page={'homepage'} />
  if (!homepageData?.data) return <Fragment />

  const componentBlockOne = () => {
    const homepageComponents = []
    homepageData.data.map((component, index) => {
      if (index >= 9) return null
      const mobileImgWidth = index === 2 || index === 3 || index === 6 || index === 7 ? '379' : heroImgWidth
      const {
        type,
        linkUrl,
        linkTitle,
        imageURL,
        altText,
        proposition,
        heading,
        subheading,
        linkTarget = '_self',
        cta,
      } = component
      return homepageComponents.push(
        <a
          data-test={type}
          className={`${styles['homepage-component']} ${styles[`homepage-component-${index + 1}`]}`}
          onClick={(event) => linkTarget !== '_blank' && onCmsClick(event, linkUrl)}
          href={linkUrl}
          title={linkTitle}
          target={linkTarget}
          key={`${linkTitle}-${index}`}>
          {type === 'proposition' ? (
            <span style={!proposition.length ? { display: 'none' } : {}} className={styles.proposition}>
              <strong>{proposition}</strong>
            </span>
          ) : imageURL ? (
            <div className={styles['homepage-image-container']}>
              <Image src={imageURL} alt={altText} width={mobileImgWidth} />
            </div>
          ) : (
            <div className={styles['homepage-text-component']}>
              <div>
                <h3>{heading}</h3>
                <p>{subheading}</p>
                <strong>{cta}</strong>
              </div>
            </div>
          )}
        </a>,
      )
    })
    return homepageComponents
  }

  const componentBlockTwo = () => {
    const homepageComponents = []
    homepageData.data.map((component, index) => {
      if (index <= 8) return null
      const { type, linkUrl, linkTitle, imageURL, altText, linkTarget = '_self' } = component

      return homepageComponents.push(
        <a
          data-test={`${type}-${index}`}
          className={`${styles['homepage-component']} ${styles[`homepage-component-${index + 1}`]}`}
          onClick={(event) => linkTarget !== '_blank' && onCmsClick(event, linkUrl)}
          href={linkUrl}
          target={linkTarget}
          title={linkTitle}
          key={`${linkTitle}-${index}`}>
          <Image data-test={linkTitle} src={imageURL} alt={altText} width='767' lazy />
        </a>,
      )
    })
    return homepageComponents
  }
  return (
    <Fragment>
      <div className={`${styles['grid-4-col']} ${styles['homepage-component-container']}`}>{componentBlockOne()}</div>
      <div className={`${styles['grid-3-col']}  ${styles['homepage-component-container']}`}>{componentBlockTwo()}</div>
    </Fragment>
  )
}

export default HomepageComponents
